import {
	ChangeDetectionStrategy,
	Component,
	OnDestroy,
	OnInit,
	inject,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { OperatorHeaderComponent } from './header/operator-header.component';
import { OperatorStateService } from '../services/state-services/operator-state.service';

@Component({
	selector: 'app-operator-shell',
	imports: [RouterOutlet, OperatorHeaderComponent],
	templateUrl: './operator-shell.component.html',
	styleUrl: './operator-shell.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperatorShellComponent implements OnInit, OnDestroy {
	readonly operatorStateSrv = inject(OperatorStateService);

	ngOnInit(): void {
		void this.operatorStateSrv.initializeContext();
	}

	ngOnDestroy(): void {
		void this.operatorStateSrv.destroy();
	}
}
